import { Injectable } from '@angular/core';
import { Router, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApplicationActions } from '../actions/application.actions';
import { FlowManagerService } from '../shared/services/flowmanager.service';

@Injectable()
export class ModelCanDeactivate implements CanDeactivate {
  constructor(
    appActions: ApplicationActions,
    flowManager: FlowManagerService,
    router: Router) {
    this.appActions = appActions;
    this.flowManager = flowManager;
    this.router = router;
  }

  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.flowManager.isSubmitting === true) {
      return false;
    } else {
      return true;
    }
  }
}
